import PropTypes from 'prop-types';
import React from 'react';
import UserNote from 'components/UserNote';
import moment from 'moment';
import PhaseType from 'types/phase';

export const appointment_updated = ({ event: { kind, data } }) => {
  const {
    start_date, end_date, arrival_start_time, arrival_end_time,
    assignee, note, scheduling_reason,
  } = data;

  let date = moment(start_date).format('MM/DD/YYYY');
  if (end_date !== start_date) {
    date += `—${moment(end_date).format('MM/DD/YYYY')}`;
  }
  const start = moment(arrival_start_time).format('h:mm a');
  const end = moment(arrival_end_time).format('h:mm a');

  return (
    <div className={kind}>
      <p><strong>Scheduling Reason:</strong> {scheduling_reason || 'N/A'}</p>
      {assignee} scheduled for {date} with arrival between {start} and {end}.
      <UserNote>{note}</UserNote>
    </div>
  );
};

appointment_updated.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      appointment_type: PropTypes.string.isRequired,
      start_date: PropTypes.string.isRequired,
      end_date: PropTypes.string.isRequired,
      arrival_start_time: PropTypes.string.isRequired,
      arrival_end_time: PropTypes.string.isRequired,
      assignee: PropTypes.string.isRequired,
      scheduling_reason: PropTypes.string,
      note: PropTypes.string,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/appointment_updated.jsx